namespace GeniuzPOS.ReportMasterData {
    export interface Report1332ShopPaymentTypeRefTypeForm {
        ShopId: Serenity.StringEditor;
        ShopName: Serenity.StringEditor;
        DocDate: Serenity.StringEditor;
        PaymentType: Serenity.IntegerEditor;
        PaymentName: Serenity.StringEditor;
        RefType: Serenity.StringEditor;
        RefName: Serenity.StringEditor;
        ExchangeRate: Serenity.DecimalEditor;
        ReceiptInAmt: Serenity.DecimalEditor;
        ReceiptOutAmt: Serenity.DecimalEditor;
        ReceiptAmt: Serenity.DecimalEditor;
    }

    export class Report1332ShopPaymentTypeRefTypeForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report1332ShopPaymentTypeRefType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report1332ShopPaymentTypeRefTypeForm.init)  {
                Report1332ShopPaymentTypeRefTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(Report1332ShopPaymentTypeRefTypeForm, [
                    'ShopId', w0,
                    'ShopName', w0,
                    'DocDate', w0,
                    'PaymentType', w1,
                    'PaymentName', w0,
                    'RefType', w0,
                    'RefName', w0,
                    'ExchangeRate', w2,
                    'ReceiptInAmt', w2,
                    'ReceiptOutAmt', w2,
                    'ReceiptAmt', w2
                ]);
            }
        }
    }
}
